import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const courierLevelDesc = async (params: object) => {
  return await GET({ url: Api.courierLevelDesc, params, showError: false })
}
